// plugins/color-mode.client.ts
export default defineNuxtPlugin(() => {
    const colorMode = useColorMode()

    watchEffect(() => {
        document.documentElement.classList.toggle('dark', colorMode.value === 'dark')
    })
})
